<template>
    <img :src="iconLoading" width="16" height="16" class="loading-image" />
</template>

<script setup lang="ts">
 const iconLoading = new URL('@/assets/image/icon-loading.svg', import.meta.url).href;
</script>

<style scoped>
.loading-image {
  align-self: center;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>